import { getTimezoneCode } from "./getTimezoneCode"

/**
 * Envia multipart/form-data sem passar pelo Axios (0.21 define
 * Content-Type: application/x-www-form-urlencoded no POST, o que no Chrome
 * Android costuma gerar Network Error em upload de áudio/arquivo).
 *
 * @param {string|number} nTicketId
 * @param {FormData} oFormData
 * @param {{ method?: 'post'|'put' }} [oOpcoes]
 * @returns {Promise<object>}
 */
export async function apiMensagemMidiaEnviar(nTicketId, oFormData, oOpcoes = {}) {
  const cMetodo = (oOpcoes.method || "post").toUpperCase()
  const cBase = process.env.REACT_APP_BACKEND_URL || ""
  const cTokenBruto = localStorage.getItem("token")
  const oHeaders = {
    timezone: localStorage.getItem("timezone") || getTimezoneCode(),
  }

  if (cTokenBruto) {
    try {
      oHeaders.Authorization = `Bearer ${JSON.parse(cTokenBruto)}`
    } catch (_) {
      oHeaders.Authorization = `Bearer ${cTokenBruto}`
    }
  }

  // Não definir Content-Type — o browser inclui boundary do multipart.
  const oResposta = await fetch(`${cBase}/messages/${nTicketId}`, {
    method: cMetodo,
    headers: oHeaders,
    body: oFormData,
    credentials: "include",
  })

  let oDados = null
  const cTipo = oResposta.headers.get("content-type") || ""
  if (cTipo.includes("application/json")) {
    try {
      oDados = await oResposta.json()
    } catch (_) {
      oDados = null
    }
  }

  if (!oResposta.ok) {
    const oErro = new Error(
      oDados?.mensagem || oDados?.error || oDados?.erro || `Falha no upload (${oResposta.status})`,
    )
    oErro.response = { status: oResposta.status, data: oDados }
    throw oErro
  }

  return oDados || {}
}
